import { inject, InjectionToken } from '@angular/core';
import { Map as LeafletMap } from 'leaflet';

export abstract class MapMode<T extends object | undefined = undefined> {
  abstract setup(): void;
  protected readonly map = inject(LassiMap);
  abstract readonly type: MapModes;
  readonly options = inject(MapModeOptions) as T;
}

export const MapModeOptions = new InjectionToken('MapModeOptions');
export const LassiMap = new InjectionToken<LeafletMap>('LassiMap');

export enum MapModes {
  PAN = 'pan',
  DRAW_ZOOM_IN = 'drawZoomIn',
  DRAW_ZOOM_OUT = 'drawZoomOut',
  VICNAMES_POLYGON_SEARCH = 'vicnamesPolygonSearch',
  SELECT = 'select',
  SELECT_SL = 'selectSurveyLabels',
  // manage survey label modes
  DRAW_SURVEY_LABEL = 'drawSurveyLabel',
  EDIT_SURVEY_LABEL = 'editSurveyLabel',
  MOVE_SURVEY_LABEL = 'moveSurveyLabel',
  // manage custom radius modes
  DRAW_CUSTOM_RADIUS = 'drawCustomRadius',
  EDIT_CUSTOM_RADIUS = 'editCustomRadius',
  MOVE_CUSTOM_RADIUS = 'moveCustomRadius',
  SELECT_COORDS = 'selectCoords',
  SELECT_SMES_COORDS = 'selectSmesCoords',
  SELECT_VICNAMES_COORDS = 'selectVicnamesCoords',
}
